import { fetchGraphQL } from 'core/services/graphQLservice' 

// getMoveAndReviewDetailsByCustomer(customerID:"${CID}")
export async function getEstimatorDetails(CID: string) {

    var params = `query{
        getEstimatorDetails(customerID:"${CID}")
        {
          customerDetails
          estimatorDet
          branchName
          branchAddress
          origin
          destination
          customerName
          customerEmail
          customerAdd1
          customerAdd2
          customerDestAdd1
          customerDestAdd2
          customerPh
          estimatorName
          estimatorEmail
          estimatorAdd1
          estimatorAdd2
          estimatorPh
          carrierName
          callBackPhone
          carrierAdd1
          carrierAdd2
        }
      }
      `;

    var response = await fetchGraphQL('POST', params);
    return response.data.getEstimatorDetails;
}